/**
 * `cn` merges Tailwind class lists so the *last* utility for a given property
 * wins, even when classes arrive from props, cva variants, and a caller's
 * `class` at once. Plain string concatenation can't resolve those conflicts
 * (e.g. `px-4` + `px-2`), so every design-system component composes its classes
 * through here. Standard shadcn/vue helper.
 */
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
